import React, { FC } from "react";
import { useController, useFormContext } from "react-hook-form";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Typography,
} from "@mui/material";

import { CheckboxInputProps } from "./types";

const StyledFormCheckbox: FC<CheckboxInputProps> = (props) => {
  const {
    name,
    title,
    rules,
    defaultValue = [],
    options,
    ...inputProps
  } = props;

  const formContext = useFormContext();
  const {
    control,
    formState: { errors: { [name]: { message = "" } = {} } = {} },
  } = formContext;

  const {
    field: { value = [], onChange },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const handleCheckboxChange =
    (checkedValue: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        onChange([...value, checkedValue]);
      } else {
        onChange(value.filter((v: string) => v !== checkedValue));
      }
    };

  return (
    <Box mb={2} textAlign="left">
      {title && (
        <Typography variant="subtitle2" color="grey800" mb={1}>
          {title}
        </Typography>
      )}
      <FormControl
        error={!!message}
        component="fieldset"
        variant="standard"
        {...inputProps}
      >
        <FormGroup>
          {options.map((option, index) => (
            <FormControlLabel
              key={`checkbox-${name}-${index}`}
              control={
                <Checkbox
                  checked={value.includes(option)}
                  onChange={handleCheckboxChange(option)}
                />
              }
              label={option}
            />
          ))}
        </FormGroup>
        <FormHelperText>
          {typeof message === "string" ? message : ""}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default StyledFormCheckbox;
